module.exports = __webpack_public_path__ + "static/media/stopwatch.448956b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stopwatch.svg
// module id = 543
// module chunks = 8